export default __webpack_public_path__ + "d3139d5d52bea19cb34559da0c026c74.svg";